import store from "@/store";

export const DICT_TYPE = 'config_map_code'

export function _query({
                           key, count = false,
                           form, where, page,
                           service, id, //replace key
                       }) {
    return new Promise((resolve, reject) => {
        let temp = {};
        if (form) {
            temp = form;
        } else {
            if (page) {
                temp = page;
            }
            if (where) {
                temp.where = mapToList(where);
            }
        }
        if (service && id) {
            doQuery(service, id, temp, count).then(res => {
                resolve(res);
            }).catch(error => reject(error));
        } else {
            _queryIdByKey(key).then(res => {
                doQuery(res.service, res.id, temp, count).then(res => {
                    resolve(res);
                }).catch(error => reject(error));
            }).catch(error => reject(error));
        }
    });
}

export function _queryIdByKey(key) {
    return new Promise((resolve, reject) => {
        let localValue = localStorage['config_map_code_' + key];
        if (localValue) {
            resolve(splitCodeConfig(localValue));
        }
        store.dispatch('api/get', {
            url: `${process.env.VUE_APP_EM_ADMIN_URL}/emDictData/query/${DICT_TYPE}/${key}`
        }).then(res => {
            if (res) {
                if (res !== localValue) {
                    localStorage['config_map_code_' + key] = res;
                    if (localValue) {
                        this.$store.commit('queryViewStore/setNeed', key);
                    }
                }
                resolve(splitCodeConfig(res));
            }
        }).catch(error => reject(error));
    });
}

function doQuery(service, id, form, count) {
    return new Promise((resolve, reject) => {
        store.dispatch('api/post', {
            url: `${process.env.VUE_APP_EM_GATEWAY_URL}/${service}/qg/ofId/${count ? 'count' : 'query'}?id=${id}`,
            data: form
        }).then(res => {
            resolve(res);
        }).catch(error => reject(error));
    });
}

function splitCodeConfig(config) {
    let index = config.indexOf(":");
    if (index > 0) {
        let service = config.substring(0, index);
        let id = config.substring(index + 1);
        return {service, id};
    }
    return {};
}

export function mapToList(where) {
    let tempList = [];
    for (let key in where) {
        let vj = where[key];
        if (vj instanceof Array
            || vj instanceof Object) {
            vj = JSON.stringify(vj);
        }
        tempList.push({
            name: key,
            valueJson: vj
        })
    }
    return tempList;
}

export function listToMap(list) {
    let where = {};
    if (list) {
        for (let item of list) {
            where[item.name] = item.valueJson;
        }
    }
    return where;
}
